






























import { Vue, Component } from "vue-property-decorator";
import Auth from "@/models/auth";
import ChangePasswordPopup from "@/components/ChangePasswordPopup.vue";

@Component({
  components: {
    ChangePasswordPopup
  }
})
export default class AppBarUserMenu extends Vue {
  items = [
    {
      icon: "mdi-key",
      text: "Đổi mật khẩu",
      onClick: this.onClickChangePassword
    },
    { icon: "mdi-logout", text: "Đăng xuất", onClick: this.logout }
  ];

  showChangePasswordPopup = false;

  onClickChangePassword() {
    this.showChangePasswordPopup = true;
  }

  logout() {
    Auth.logout();
  }
}
